(function () {
  var GOOGLE_MAPS_API_KEY = 'AIzaSyAnGzuAbh4PiQ2xQ1wwD0Bw_aXGcZvAN7I';
  var SCRIPT_ID = 'store-detail-google-maps-api';
  var CALLBACK_NAME = 'initStoreDetailGoogleMaps';
  var PIN_ICON_URL = 'https://cdn.shopify.com/s/files/1/0578/8001/8989/files/Pin_TMU.png?v=1734532859';
  var mapsReady = false;
  var mapsLoading = false;

  var mapStyles = [
    { elementType: 'geometry', stylers: [{ color: '#e8eef4' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#6d7f92' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f4f8fc' }] },
    { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c6d4e1' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#dfe8f1' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dbe7d3' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#c9dceb' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#b4cadb' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#62788f' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c7dbeb' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#5d748a' }] }
  ];

  function initializeMapNode(mapEl) {
    if (!mapEl || mapEl.dataset.mapInitialized === 'true') return;

    var address = (mapEl.getAttribute('data-address') || '').trim();
    if (!address || !window.google || !window.google.maps) return;

    mapEl.dataset.mapInitialized = 'true';

    var map = new google.maps.Map(mapEl, {
      center: { lat: 40.4168, lng: -3.7038 },
      zoom: 16,
      minZoom: 13,
      maxZoom: 19,
      disableDefaultUI: true,
      gestureHandling: 'greedy',
      clickableIcons: false,
      styles: mapStyles
    });

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === 'OK' && results && results[0]) {
        var location = results[0].geometry.location;
        map.setCenter(location);

        new google.maps.Marker({
          position: location,
          map: map,
          icon: {
            url: PIN_ICON_URL,
            scaledSize: new google.maps.Size(36, 60),
            anchor: new google.maps.Point(24, 60)
          }
        });
      }
    });
  }

  function initAllMaps() {
    if (!window.google || !window.google.maps) return;
    document.querySelectorAll('.js-store-detail-map').forEach(initializeMapNode);
  }

  window[CALLBACK_NAME] = function () {
    mapsReady = true;
    mapsLoading = false;
    initAllMaps();
  };

  function loadMapsScript() {
    if (mapsReady || mapsLoading || document.getElementById(SCRIPT_ID)) return;
    mapsLoading = true;
    var script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(GOOGLE_MAPS_API_KEY) +
      '&callback=' +
      encodeURIComponent(CALLBACK_NAME) +
      '&v=weekly';
    script.async = true;
    script.defer = true;
    script.onerror = function () {
      mapsLoading = false;
    };
    document.head.appendChild(script);
  }

  function bootMaps() {
    var hasMap = !!document.querySelector('.js-store-detail-map');
    if (!hasMap) return;

    if (window.google && window.google.maps) {
      mapsReady = true;
      initAllMaps();
      return;
    }

    loadMapsScript();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMaps);
  } else {
    bootMaps();
  }

  document.addEventListener('shopify:section:load', function () {
    bootMaps();
  });
})();
